import { ComingUpFeatureItem } from '../types'

export const COMING_UP_FEATURES: ComingUpFeatureItem[] = [
  {
    type: 'NEW FEATURE',
    title: 'Roles and permissions',
    description:
      'Control who can view your data, so you can collaborate with confidence and keep your work secure.',
    href: '',
  },
  {
    type: 'NEW FEATURE',
    title: 'Enhanced workspaces',
    description: 'Group, compare and organise your adaptation work.',
    href: 'https://forum.resilience-explorer.com/t/enhanced-workspaces-group-compare-and-organise-your-adaptation-work/63',
  },
  {
    type: 'NEW FEATURE',
    title: 'Risk profiles',
    description:
      'Aggregated risk results in an easy to understand dashboard encompassing built, social and economic insights.',
    href: 'https://forum.resilience-explorer.com/t/would-prefer-your-risk-results-as-a-dashboard-rather-than-map/54',
  },
  {
    type: 'NEW FEATURE',
    title: 'Risk module redesign',
    description:
      'An easier to use version of the freeform map which will include function state, social and economic results.',
    href: 'https://forum.resilience-explorer.com/t/risk-module-redesign/49',
  },
]
